import React, { useState } from "react";
import Header from '../shared/header';
import UserPool from "../UserPool";
import { CognitoUser, CognitoUserAttribute } from "amazon-cognito-identity-js"
import './login.scss';
import {useNavigate} from 'react-router-dom';
import { SnackbarOrigin, Snackbar  } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const Signup = () => {
    const [stateMsg, setStateMsg] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = stateMsg;
    const [msg, setMsg] = useState("")
    const [severity, setSeverity] = useState("")
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [company, setCompany] = useState("");
    const [code, setCode] = useState("");
    const [confirm, setConfirm] = useState(false);
    const [response, setData] = useState(null);
    let navigate = useNavigate();
    const messageBox = (severity, msg) => {
        setSeverity(severity)
        setMsg(msg)
        var newState = {
            vertical: 'top',
            horizontal: 'center',
        }
        setStateMsg({ open: true, ...newState });
    }
    const handleClose = () => {
        setStateMsg({ ...stateMsg, open: false });
    };
    const onSubmit = (event) => {

        event.preventDefault();
        if (name.trim().length === 0 || email.trim().length === 0 || password.trim().length === 0) {
            return;
        }
        let attributeList = [
            new CognitoUserAttribute({
                Name: 'given_name', Value: name
            }),
            new CognitoUserAttribute({
                Name:'nickname', Value:company
            }),
            new CognitoUserAttribute({
                Name:'email', Value:email
            })
        ];
        let verificationCode = code;
        if(!confirm)
        {
            UserPool.signUp(username, password, attributeList, null, (err, data) => {
                if (err) {
                    var msg = "";
                    messageBox("error",err.message)
                }
                else if(data) {
                    if(!data['userConfirmed'])
                    {
                        setConfirm(true);
                        const userInfo = {
                            Username:data['user'].getUsername(),
                            Pool:data['user']['pool'],
                        }
                        setData(userInfo);
                        messageBox("success","Email Verification")
                    }
                }
                console.log(data);
            })
        }
        
        if(verificationCode && verificationCode.length !== 0 && confirm)
        {
            let confirm = new CognitoUser(response)
            confirm.confirmRegistration(verificationCode, true, function (err, result) {
                if (err) {
                    console.log(err);
                    messageBox("error",err.message)
                }
                else {
                    console.log(result)
                    setConfirm(false)
                    messageBox("success","Success")
                    navigate("/login");
                }
            });
        }

       
        
    }

    return (
        <div>
            <Header isSignUp={false}/>
            <div className="bg-img">
                <form onSubmit={onSubmit} className='main-div'>

                    <div className="margin-bottom-15">
                        <h3>Sign Up</h3>

                    </div>
                    {/* {errorMessage} */}
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" className={name.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={name} onChange={(event) => setName(event.target.value)} placeholder="Enter name" />
                        <label for="validationError" class="form-label text-danger">{name.trim().length == 0 ? "name is required" : ""}</label>
                    </div>
                    <div className="form-group">
                        <label>Company</label>
                        <input type="text" className={company.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={company} onChange={(event) => setCompany(event.target.value)} placeholder="Enter company" />
                        <label for="validationError" class="form-label text-danger">{company.trim().length == 0 ? "company is required" : ""}</label>
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" className={email.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={email} onChange={(event) => setEmail(event.target.value)} placeholder="Enter email" />
                        <label for="validationError" class="form-label text-danger">{email.trim().length == 0 ? "email is required" : ""}</label>
                    </div>
                    <div className="form-group">
                        <label>User Name</label>
                        <input type="text" className={username.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={username} onChange={(event) => setUsername(event.target.value)} placeholder="Enter username" />
                        <label for="validationError" class="form-label text-danger">{username.trim().length == 0 ? "username is required" : ""}</label>
                    </div>
                    <div className="form-group ">
                        <label>Password</label>
                        <input type="password" className={password.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Enter password" />
                        <label for="validationError" class="form-label text-danger">{password.trim().length == 0 ? "password is required" : ""}</label>
                    </div>
                    {confirm ?
                        <div>
                            <div className="form-group ">
                                <label>Code</label>
                                <input type="text" className={code.trim().length == 0 ? 'form-control is-invalid' : 'form-control'} value={code} onChange={(event) => setCode(event.target.value)} placeholder="Enter confirmation code" />
                                <label for="validationError" class="form-label text-danger">{code.trim().length == 0 ? "code is required" : ""}</label>
                            </div>

                            <div class="o-form-button-bar"><input class="btn btn-primary" type="submit" value="Confirm User" id="signup-submit" data-type="save" /></div>
                        </div>

                        :
                        <div class="o-form-button-bar"><input class="btn btn-primary" type="submit" value="Sign Up" id="signup-submit" data-type="save" /></div>
                    }
                    
                    
                    
                </form>
            </div>
            
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                key={vertical + horizontal}
            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {msg}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Signup;